import { apiGet, apiPost } from "./http";

export type ActivityRegistrationDocSignatureRecord = {
  fileLegacyId: string;
  fileName: string;
  version: string;
  content: string;
  signedAt: string;
  signatureDataUrl: string;
  signatureKind: string;
};

export type ActivityRegistrationDocSignaturesResponse = {
  registrationId: string;
  activityId: string;
  activityTitle: string;
  memberLegacyId?: string | null;
  memberName: string;
  requireDocSign: boolean;
  requiredDocCount: number;
  documents: ActivityRegistrationDocSignatureRecord[];
};

function mapDocSignatureRecord(d: unknown): ActivityRegistrationDocSignatureRecord | null {
  if (!d || typeof d !== "object") return null;
  const o = d as Record<string, unknown>;
  const fileLegacyId = String(o.fileLegacyId ?? "").trim();
  if (!fileLegacyId) return null;
  return {
    fileLegacyId,
    fileName: String(o.fileName ?? "").trim(),
    version: String(o.version ?? "").trim(),
    content: String(o.content ?? ""),
    signedAt: String(o.signedAt ?? "").trim(),
    signatureDataUrl: String(o.signatureDataUrl ?? "").trim(),
    signatureKind: String(o.signatureKind ?? "draw").trim() || "draw",
  };
}

function mapResponse(res: unknown): ActivityRegistrationDocSignaturesResponse {
  const o = res && typeof res === "object" ? (res as Record<string, unknown>) : {};
  const docsRaw = o.documents;
  const documents = Array.isArray(docsRaw)
    ? docsRaw.map(mapDocSignatureRecord).filter((x): x is ActivityRegistrationDocSignatureRecord => x != null)
    : [];
  return {
    registrationId: String(o.registrationId ?? ""),
    activityId: String(o.activityId ?? ""),
    activityTitle: String(o.activityTitle ?? ""),
    memberLegacyId: o.memberLegacyId != null ? String(o.memberLegacyId) : null,
    memberName: String(o.memberName ?? ""),
    requireDocSign: Boolean(o.requireDocSign),
    requiredDocCount: Number(o.requiredDocCount ?? 0),
    documents,
  };
}

/** PC 管理后台：查看活动报名签署存档 */
export async function fetchActivityRegistrationDocSignatures(
  tenantLegacyId: string,
  registrationLegacyId: string,
): Promise<ActivityRegistrationDocSignaturesResponse> {
  const res = await apiGet<unknown>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/activity-registrations/${encodeURIComponent(registrationLegacyId)}/doc-signatures`,
  );
  return mapResponse(res);
}

/** 会员端：查看本人在某活动的报名签署存档 */
export async function fetchMyActivityRegistrationDocSignatures(
  tenantLegacyId: string,
  activityLegacyId: string,
  body: { memberLegacyId: string; wxOpenId: string },
): Promise<ActivityRegistrationDocSignaturesResponse & { found?: boolean }> {
  const res = await apiPost<unknown>(
    `/api/tenants/${encodeURIComponent(tenantLegacyId)}/activities/${encodeURIComponent(activityLegacyId)}/registrations/mine/doc-signatures`,
    body,
  );
  const mapped = mapResponse(res);
  const o = res && typeof res === "object" ? (res as Record<string, unknown>) : {};
  return { ...mapped, found: o.found != null ? Boolean(o.found) : true };
}
